import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Checkbox, DatePicker, Input, Select, Switch } from "antd";
import { Countries } from "./Countries";
import style from "./checkout.module.scss";
import { detectCardType, normalizeParam } from "./utills";
import { uuidv4 } from "../Thankyou/Utills";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import PaypalPayment from "../subscription/SubsPayPalPayment";
import Alreadypurchased from "../AlreadyPurchased/alreadypurchased";
import CyberSource from "./CyberSource";
import { checkoutSettingsDefaultData, callrzpSubscription } from "./utills";
import { getWordsFromDuration } from "./utills";
import { antdMessageError } from "./utills";
import API from "../../Api/api";
import { Benifits } from "./Benifits";
import Loader from "../loader";
import { ReactComponent as DropDownArrow } from "../../assets/dropdown_arrow.svg";
import { ReactComponent as SelectArrowIcon } from "../../assets/select_arrow_icon.svg";
import { ReactComponent as CalenderIcon } from "../../assets/DateRange_Icon.svg";
import { ReactComponent as AddPlusIcon } from "../../assets/Add_plus_icon.svg";
import Mobile_icon from "../../assets/mobile_icon.svg";
import Search_icon from "../../assets/search_icon.svg";
import AmericanExpressIcon from "../../assets/American_icon.svg";
import VisaCard from "../../assets/Visa_icon.svg";
import MasterCard from "../../assets/masterCard_icon.svg";
import DinerClubCard from "../../assets/Diners_icon.svg";
import DiscoverCard from "../../assets/discover.svg";
import JcbCard from "../../assets/jcb_icon.svg";
import { Country_flag_json } from "../../consts/country-flag-json";
import dropDownStyle from "../../UI/DropDown/commonAntdSelectedBox.module.scss";
import CustomDropDownForSelect from "../../UI/DropDown/CustomDropDown";
import { AddCardDetails } from "./AddCardDetails";
import { AddAddress } from "./AddAddress";
import { SavedAddress } from "./SaveAddress";
import { ApplyCoupon } from "./ApplyCoupon";
import StepUpForm from "./StepUpForm";
import SubsStripePayment from "../subscription/SubsStripePayment";
import { Footer } from "./Footer";
import dayjs from "dayjs";
import { getCurrencySymbol } from "../currencies";
import { jwtDecode } from "jwt-decode";

const Checkout = () => {
  const [contantDetails, setContantDetails] = useState(true);
  const [footerSettings, setFooterSettings] = useState({} as any);
  const [showStepUp, setShowStepUp] = useState(false);
  const [stepUpUrl, setStepUrl] = useState("");
  const [editingAddress, setEditingAddress] = useState(null);
  const [editingIndex, setEditingIndex] = useState<string | null>(null);
  const [triggerApi, setTriggerApi] = useState(false);
  const [userDetails, setUserDetails] = useState({
    address: {},
    billingAddress: [],
    name: "",
    phoneNumber: "",
    secondaryEmail: "",
    secondaryPhone: "",
    shippingAddress: [],
    // email: "",
    dateOfBirth: "",
    gender: "",
    countryCode: "",
    isEmailVerified: false,
    isPhoneVerified: false,
    userTaxId: "",
  } as any);
  const [subsDetailsData, setSubsDetailsData] = useState({
    benefits: "",
    convertedPrice: 0,
    currency: "",
    duration: 0,
    name: "",
    originalPrice: 0,
    proRataDiscount: 0,
    gift: {
      giftEnabled: false,
      gifting: "OPTIONAL",
    },
    adFree: false,
    digital: false,
    physical: false,
    billingCycleType: "RECURRING",
    couponDiscountPrice: 0,
    epaper: false,
    durationType: "",
    countries: [],
    // discounts: [{ amount: 0 }],
  });
  const [checkoutSetting, setCheckoutSetting] = useState(
    checkoutSettingsDefaultData
  );
  const [ssoRedirectUrl, setSSOredirectUrl] = useState("");
  const [slpDomain, setSlpDomain] = useState("");
  const [buttonLoading, setbuttonLoading] = useState(false);
  const [orderSummary, setOrderSummary] = useState(true);
  const [showAddress, setShowAddress] = useState(false);
  const [cyberSourcedata, setCyberSourcedata] = useState({
    accessToken: "",
    deviceDataCollectionUrl: "",
    refrenceId: "",
  });
  const [cyberSourceSessionId, setCyberSourceSessionId] = useState("");
  const [randomUUid, setRandomUUid] = useState(uuidv4());
  const [subscriptionContentDetails, setsubscriptionContentDetails] = useState(
    {}
  );
  const [cardToken, setCardToken] = useState("");
  const [tax, settax] = useState(0);
  const [renewAmount, setRenewAmount] = useState(0);
  const [inclusiveTax, setInclusiveTax] = useState(0);
  const [isPurchased, setisPurchased] = useState(false);
  const [giftcouponCode, setGiftCouponCode] = useState<string | undefined>(undefined);
  // const [month, setMonth] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cardHolderName, setCardHolderName] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [redirects, setRedirects] = useState({ privPolicy: "", tnc: "" });
  // const [year, setYear] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardType, setCardType] = useState("");
  const [refreshData, setRefreshData] = useState(false);
  const giftedByUserRef = useRef<string | null>(null);
  const gifterPurchaseIdRef = useRef<string | null>(null);
  const isGiftCouponRef = useRef<boolean>(false);
  const searchParams = new URLSearchParams(window.location.search);
  const [unifiedMethods,setUnifiedMethods] = useState([])
  const [supportApple,setSupportApple] = useState(false);
  const [device,SetDevice] = useState('');
  const [priceLoading , setPriceLoading] = useState(true);
  const showgift = searchParams.get("showgift") || giftcouponCode;
  const sendviewEvent = () => {
    console.log("ljfhuierhior",window.location.origin);
    const SRPviewObject = {
      eventType: "VIEW",
      eventLocation: "SRP",
      subId: searchParams.get("subsId"),
      landingPageId: searchParams.get("landingPageId"),
      tierId: searchParams.get("tierId"),
      amount: subsDetailsData.convertedPrice,
      currency: subsDetailsData.currency,
      clientId: searchParams.get("clientId"),
      contentId: searchParams.get("clientContentId"),
      anonId: searchParams.get("anonId"),
      paywallId: normalizeParam(searchParams.get("paywallId")),
      paywallType: normalizeParam(searchParams.get("paywallType")),
      userId: userDetails._id,
      url : window.location.origin,
    };
    navigator.sendBeacon(
      `${process.env.REACT_APP_KAFKA_URL}collect/event`,
      JSON.stringify({
        messageBody: [{ ...SRPviewObject }],
      })
    );
  };
  const sendClickEvent = () => {
    const SRPviewObject = {
      clickAction: "P2P",
      eventLocation: "SRP",
      subId: searchParams.get("subsId"),
      tierId: searchParams.get("tierId"),
      amount: subsDetailsData.convertedPrice,
      currency: subsDetailsData.currency,
      clientId: searchParams.get("clientId"),
      contentId: searchParams.get("clientContentId"),
      anonId: searchParams.get("anonId"),
      paywallId: normalizeParam(searchParams.get("paywallId")),
      purchaseType: "SUBSCRIPTION",
      eventType: "CLICK",
      landingPageId: searchParams.get("landingPageId"),
      paywallType: normalizeParam(searchParams.get("paywallType")),
      userId: userDetails._id,
      url : window.location.origin,
    };
    navigator.sendBeacon(
      `${process.env.REACT_APP_KAFKA_URL}collect/event`,
      JSON.stringify({
        messageBody: [{ ...SRPviewObject }],
      })
    );
  };

  const couponCode = searchParams.get("couponCode") || "";
  const slpGift = searchParams.get("slpGift");
  const [showRenewline, setshowRenewline] = useState(false);

  const [showRenew, setShowRenew] = useState(true);
  const [isPaypal, setisPaypal] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [internelTYransactionId, setInternelTransactionId] = useState("");
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [renew, setRenew] = useState(false);
  const [isGift, setIsGift] = useState(false);
  const [isGiftMandatory, setIsGiftMandatory] = useState(false);
  const [recipientEmail, setrecipientEmail] = useState("");
  const [recipientName, setrecipientName] = useState("");
  const [recieverMessage, setRecieverMessage] = useState("");
  const [sender, setsender] = useState("");
  const [stepUpToken, setStepUpToken] = useState("");
  const [isStripe, setisStripe] = useState(false);
  const [checkoutCoupon, setCheckoutCoupon] = useState(couponCode);
  const subsIdRef = useRef<string | null>(null);
  const clientIdRef = useRef<string | null>(null);
  const isCouponValid = useRef(false);
  const removedSlpCoupon = useRef(false);
  const deviceType = window.innerWidth <= 768 ? 'MOBILE' : 'DESKTOP';
  // const [removedSlpCoupon, setRemovedSlpCoupon] = useState(false);
  const activeCoupon =
    !removedSlpCoupon && couponCode ? couponCode : checkoutCoupon;
    function cleanPaymentMethods(methods: string[]) {
      return methods
        .filter(method => method === 'GOOGLE_PAY' || method === 'APPLE_PAY').map(method => method.replace(/_/g, ''));
    }
    function transformToArray(input: string): string[] {
      return input.split(',').map(item => item.trim());
    }

  const getOS = () => {
  const userAgent = window.navigator.userAgent;
  if (/Android/.test(userAgent)) return 'ANDROID';
  if (/iPhone|iPad|iPod/.test(userAgent)) return 'IOS';
  };

  const detectDevice = () =>{
    const searchParams = new URLSearchParams(window.location.search);
    const App = searchParams.get("mobileview") || false;

    if(App){
      const os = getOS();
      return `${os}_APP` ;
    }else{
      return `${deviceType}_WEB`
    }
   }

  useEffect(() => {
    window.addEventListener("message", (message) => {
      const secondStep =
        new URLSearchParams(window.location.search).get("secondStep") || "";
      const thirdstep =
        new URLSearchParams(window.location.search).get("thirdStep") ||
        undefined;
      const popUpId =
        new URLSearchParams(window.location.search).get("popUpId") || undefined;
      const secondaryDetails =
        new URLSearchParams(window.location.search).get("secondaryDetails") ||
        undefined;
      console.log(message, "message");
      if (message.data.source === "Transaction-Complete") {
        setShowStepUp(false);
        const url = new URL(
          `${window.location.origin
          }/thankyou?transactionId=${transactionId}&clientContentId=${searchParams.get(
            "clientContentId"
          )}&clientId=${searchParams.get(
            "clientId"
          )}&secondStep=${secondStep}&thirdstep=${thirdstep}&popUpId=${popUpId}&secondaryDetails=${secondaryDetails}`
        );
        window.location.href = url.toString();
      }
      if (message.data.source === "Transaction-Failed") {
        window.location.reload();
      }
    });

    SetDevice(detectDevice());
  }, []);

  useEffect(() => {
    setPriceLoading(true);
    (async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const paymentMethod = searchParams.get("paymentMethod") || "";
      const changedtostring = paymentMethod.split(',');
      const changedtoArray = cleanPaymentMethods(changedtostring);
      // @ts-ignore
      setUnifiedMethods(changedtoArray);
      const couponCode = searchParams.get("couponCode") || "";
      const numberOfLicense = Number(searchParams.get("numberOfLicense"));
      const getData = await API.user.getCheckoutSettings({
        clientId: searchParams.get("clientId"),
      });
      setRedirects(getData.data.redirects);
      localStorage.setItem("tnc", getData.data.redirects.tnc);
      localStorage.setItem("privPolicy", getData.data.redirects.privPolicy);
      setFooterSettings(getData?.data?.footer);

      setCheckoutSetting(getData.data.result);
      let digitalTaxRate = 0;
      let physicalTaxRate = 0;
      const includeTaxInPrice = getData?.data?.includeTaxInPrice;
      // const taxdata=getData?.data?.taxConfig;
      if (getData?.data.taxConfig[0]?.categories[0] === "DIGITAL") {
        digitalTaxRate = getData?.data?.taxConfig[0]?.taxes[0]?.taxRate || 0;
      }
      if (getData?.data.taxConfig[0]?.categories[0] === "PHYSICAL") {
        physicalTaxRate = getData?.data?.taxConfig[0]?.taxes[0]?.taxRate || 0;

        // const digitalTaxRate=getData?.data?.taxConfig[1]?.taxes[0]?.taxRate||0;
      }
      if (getData?.data.taxConfig.length > 1) {
        if (getData?.data.taxConfig[1]?.categories[0] === "DIGITAL") {
          digitalTaxRate = getData?.data?.taxConfig[1]?.taxes[0]?.taxRate || 0;
        }
        if (getData?.data.taxConfig[1]?.categories[0] === "PHYSICAL") {
          physicalTaxRate = getData?.data?.taxConfig[1]?.taxes[0]?.taxRate || 0;

          // const digitalTaxRate=getData?.data?.taxConfig[1]?.taxes[0]?.taxRate||0;
        }
      }
      // console.log(physicalTaxRate,digitalTaxRate,'dsjhiudshfcoi')

      setSSOredirectUrl(getData.data.ssoRedirectUrl);
      setSlpDomain(getData.data.slpDomain);
      localStorage.setItem("ssoRedirectUrl", getData.data.ssoRedirectUrl);

      let accessToken = localStorage.getItem("accessToken");

      if (accessToken != undefined && accessToken.length > 18) {
        // setTimeout(() => {
        //   getUserDetials();
        // }, 400);
        const delay = (ms: any) => new Promise((res) => setTimeout(res, ms));
        await delay(10);
        // await getUserDetials();
        const queryData = new URLSearchParams(window.location.search);
        const subsId = queryData.get("subsId") || queryData.get("subId") || "";
        const tierId = queryData.get("tierId") || "";
        const clientId = queryData.get("clientId") || "";
        subsIdRef.current = subsId;
        clientIdRef.current = clientId;
        const data = await API.user.getSubsDetails({
          subsId,
          tierId,
          clientId,
          accessToken: "sdfd",
          numberOfLicense: numberOfLicense,
          couponCode: activeCoupon,
        });
        if(data.data.isGiftCoupon){
          setGiftCouponCode('false')
          setIsGift(false)
          giftedByUserRef.current = data.data.giftedByUser;
          gifterPurchaseIdRef.current = data.data.gifterPurchaseId;
          isGiftCouponRef.current = true;
        }
        // window.location.href=`${process.env.REACT_APP_SUB_URL}/alreadyPurchased?clientId=${clientId}&duration=${data.data.duration}&title=${data.data.name}`

        if (data.data.isPurchaseExists || !data?.data?.allowPurchase) {
          setisPurchased(true);
        }

        const routingData = await callRoutingConfig();
        //hardcoding to check for cybersource
        //  routingData.gateway='CYBERSOURCE'
        const Methods = cleanPaymentMethods(routingData?.paymentMethod);
        // @ts-ignore
        setUnifiedMethods(Methods);
        if (queryData.get("amount")) {
          const y = Countries.filter((data1) => {
            return data?.data?.countries?.find((ele: any) => ele == data1.code);
          });

          console.log(y, "poiuyt1", data.data);
          setSubsDetailsData({
            ...data.data,
            convertedPrice: queryData.get("amount"),
            proRataDiscount: 0,
            originalPrice: queryData.get("amount"),
            currency: queryData.get("currency"),
            countries: [...y],
          });
          setPriceLoading(false);
          data.data.convertedPrice = queryData.get("amount");
          data.data.originalPrice = queryData.get("amount");
          data.data.currency = queryData.get("currency");
        } else {
          const y = Countries.filter((data1) => {
            return data?.data?.countries?.find(
              (ele: any) => ele === data1.code
            );
          });
          console.log(y, "poiuyt2");
          setSubsDetailsData({ ...data.data, countries: [...y] });
          setPriceLoading(false);
        }
        if (!includeTaxInPrice) {
          if(data.data.digital && data.data.physical){
            let totalTax = 0;
            let digitalTaxAmount = 0;
            let physicalTaxAmount = 0;
          
            const discountRatio = data.data.convertedPrice / data.data.originalPrice;
          
            if (digitalTaxRate) {
              const digitalComponent = data.data.gstComponents?.digital * discountRatio;
              digitalTaxAmount = (digitalTaxRate / 100) * digitalComponent;
              totalTax += digitalTaxAmount;
            }
          
            if (physicalTaxRate) {
              const physicalComponent = data.data.gstComponents?.physical * discountRatio;
              physicalTaxAmount = (physicalTaxRate / 100) * physicalComponent;
              totalTax += physicalTaxAmount;
            }
          
            settax(totalTax);
            setRenewAmount(totalTax + data.data.convertedPrice);

          }else{
            if (data.data.digital) {
              if (digitalTaxRate) {
                settax((digitalTaxRate / 100) * data.data.convertedPrice);
                setRenewAmount(
                  data.data.originalPrice +
                    (digitalTaxRate / 100) * data.data.originalPrice
                );
  
                // setTaxBeforeDiscount((digitalTaxRate / 100) * data.data.originalPrice)
              } else {
                setRenewAmount(data.data.originalPrice);
              }
            }
            if (data.data.adFree) {
              if (digitalTaxRate) {
                settax((digitalTaxRate / 100) * data.data.convertedPrice);
                setRenewAmount(
                  data.data.originalPrice +
                    (digitalTaxRate / 100) * data.data.originalPrice
                );
  
                // setTaxBeforeDiscount((digitalTaxRate / 100) * data.data.originalPrice)
              } else {
                setRenewAmount(data.data.originalPrice);
              }
            }
            if (data.data.physical) {
              if (physicalTaxRate) {
                settax((physicalTaxRate / 100) * data.data.convertedPrice);
                setRenewAmount(
                  data.data.originalPrice +
                    (physicalTaxRate / 100) * data.data.originalPrice
                );
  
                // setTaxBeforeDiscount((physicalTaxRate / 100) * data.data.convertedPrice);
              } else {
                setRenewAmount(data.data.originalPrice);
              }
            }
            if (data.data.epaper) {
              if (digitalTaxRate) {
                settax((digitalTaxRate / 100) * data.data.convertedPrice);
                setRenewAmount(
                  data.data.originalPrice +
                    (digitalTaxRate / 100) * data.data.originalPrice
                );
              } else {
                setRenewAmount(data.data.originalPrice);
              }
            }
          }
        } else {
          if (data.data.digital || data.data.adFree) {
            if (digitalTaxRate) {
              let tax1 =
                (data.data.convertedPrice * digitalTaxRate) /
                (100 + digitalTaxRate);
              setInclusiveTax(tax1);
              const y = Countries.filter((data1) => {
                return data?.data?.countries?.find(
                  (ele: any) => ele == data1.code
                );
              });
              console.log(y, "poiuyt3");
              setSubsDetailsData({
                ...data.data,
                countries: [...y],
              });
              setPriceLoading(false);
            }
            setRenewAmount(data.data.originalPrice);
          }
          if (data.data.adFree) {
            if (digitalTaxRate) {
              let tax1 =
                (data.data.convertedPrice * digitalTaxRate) /
                (100 + digitalTaxRate);
              setInclusiveTax(tax1);
              const y = Countries.filter((data1) => {
                return data?.data?.countries?.find(
                  (ele: any) => ele == data1.code
                );
              });
              console.log(y, "poiuyt3");
              setSubsDetailsData({
                ...data.data,
                countries: [...y],
              });
              setPriceLoading(false);
            }
            setRenewAmount(data.data.originalPrice);
          }
          if (data.data.physical) {
            setRenewAmount(data.data.originalPrice);

            if (physicalTaxRate) {
              let tax1 =
                (data.data.convertedPrice * physicalTaxRate) /
                (100 + physicalTaxRate);
              // settax(tax);
              setInclusiveTax(tax1);
              const y = Countries.filter((data1) => {
                return data?.data?.countries?.find(
                  (ele: any) => ele == data1.code
                );
              });
              console.log(y, "poiuyt4");
              setSubsDetailsData({
                ...data.data,
                countries: [...y],
              });
              setPriceLoading(false);
              // settax((physicalTaxRate / 100) * data.data.convertedPrice);
            }
          }
          if (data.data.epaper) {
            console.log("kjdshui6");

            setRenewAmount(data.data.originalPrice);

            if (digitalTaxRate) {
              let tax1 =
                (data.data.convertedPrice * digitalTaxRate) /
                (100 + digitalTaxRate);
              setInclusiveTax(tax1);
              const y = Countries.filter((data1) => {
                return data?.data?.countries?.find(
                  (ele: any) => ele == data1.code
                );
              });
              console.log(y, "poiuyt5");
              setSubsDetailsData({
                ...data.data,
                countries: [...y],
                // convertedPrice: convertedPrice,
              });
              setPriceLoading(false);
              // settax((digitalTaxRate / 100) * data.data.convertedPrice);
            }
          }
        }

        if (data.data.billingCycleType === "RECURRING") {
          setshowRenewline(true);

          setShowRenew(false);
          // setRenew(true);
          if (showgift) {
            setRenew(false);
          } else {
            setRenew(true);
          }
        }
        if (data.data.billingCycleType === "ONE_TIME") {
          setShowRenew(false);
          setRenew(false);
        }
        if (data.data.billingCycleType === "BOTH_DEFAULT_UNCHECKED_RECURRING") {
          setShowRenew(true);
          setRenew(false);
        }
        if (data.data.billingCycleType === "BOTH_DEFAULT_CHECKED_RECURRING") {
          setShowRenew(true);
          setRenew(true);
        }

        //  routingData.gateway='CYBERSOURCE'

        if (routingData.gateway === "CYBERSOURCE") {
          const data = await API.payment.getCardDetails({ clientId });
          data.data.cardDetails.map((card: any) => {
            if (card.isDefault === true) {
              setCardToken(card._id);
            }
          });
          setCardDetails([...data.data.cardDetails]);
        }
        // sendviewEvent(data.data);
      } else {
        const queryData = new URLSearchParams(window.location.search);
        const subsId = queryData.get("subsId") || queryData.get("subId") || "";
        const tierId = queryData.get("tierId") || "";
        const clientId = queryData.get("clientId") || "";
        // const querySelector=
        const data = await API.user.getSubsDetailsAnon({
          subsId,
          tierId,
          clientId,
          numberOfLicense: numberOfLicense,
          couponCode: activeCoupon,
        });
        if(data.data.isGiftCoupon){
          setGiftCouponCode('false')
          setIsGift(false)
          giftedByUserRef.current = data.data.giftedByUser;
          gifterPurchaseIdRef.current = data.data.gifterPurchaseId;
          isGiftCouponRef.current = true;
        }
        const y = Countries.filter((data1) => {
          return data?.data?.countries?.find((ele: any) => ele == data1.code);
        });
        console.log(y, "poiuyt6");
        setSubsDetailsData({ ...data.data, countries: [...y] });
        setPriceLoading(false);
      }
    })();
  }, [checkoutCoupon]);
  useEffect(() => {
    (async () => {
      await getUserDetials();
    })();
  }, []);
  useEffect(() => {
    getUserDetials();
  }, [triggerApi]);
  useEffect(() => {
    if (subsDetailsData.currency != "") {
      sendviewEvent();
    }
  }, [subsDetailsData]);
  useEffect(() => {
    console.log(unifiedMethods , "unified Methods")
    if (subsDetailsData.currency != "") {
      getApplePay({price:subsDetailsData?.convertedPrice + tax, currency: subsDetailsData?.currency});
    }
  }, [subsDetailsData,renew,unifiedMethods]);
  useEffect(() => {
    if (stepUpToken && stepUpToken.length > 10) {
      setShowStepUp(true);
      setLoading(true);
    }
  }, [stepUpToken]);
  const [loading, setLoading] = useState(true);
  const [address, setAddress] = useState({
    name: "",
    state: "",
    country: "",
    pincode: "",
    area: "",
  });
  const [billingAddress, setBillingAddress] = useState({
    name: "",
    state: "",
    country: "",
    pincode: "",
    area: "",
  });

  const [cardDetails, setCardDetails] = useState([] as any);
  const [routing, setRouting] = useState({
    color: "",
    gateway: "",
    logoUrl: "",
    publishable_key: "",
    clientName: "",
    merchantId: "poiuytyuiop",
    paymentMethod : [],
  });
  const handleCardType = (type: string) => {
    if (type === "VS") {
      return VisaCard;
    } else if (type === "MS") {
      return MasterCard;
    } else if (type === "AMEX") {
      return AmericanExpressIcon;
    } else if (type === "DS") {
      return DiscoverCard;
    } else if (type === "DINER") {
      return DinerClubCard;
    } else if (type === "JCB") {
      return JcbCard;
    }
  };
  const [billingSameAsShipping, setbillingSameAsShipping] = useState(false);
  const [indexOfShipingAddress, setIndexOfShipingAddress] = useState(0);
  useEffect(() => {
    if (
      Array.isArray(userDetails?.shippingAddress) &&
      userDetails?.shippingAddress[indexOfShipingAddress]
    ) {
      setAddress({ ...userDetails.shippingAddress[indexOfShipingAddress] });
    }
  }, [indexOfShipingAddress, userDetails?.shippingAddress]);
  useEffect(() => {
    if (checkoutSetting.deliveryAddress.default && subsDetailsData.physical) {
      setShowAddress(true);
    } else {
      // alert('one')
      if (
        (checkoutSetting.deliveryAddress.customization.adsFreeSubscription
          .isRequired &&
          subsDetailsData.adFree) ||
        (checkoutSetting.deliveryAddress.customization.digitalSubscription
          .isRequired &&
          subsDetailsData.digital) ||
        (checkoutSetting.deliveryAddress.customization.physicalSubscription
          .isRequired &&
          subsDetailsData.physical)
      ) {
        // alert('two')

        setShowAddress(true);
      }
    }

    // )
  }, [checkoutSetting, subsDetailsData]);
  useEffect(() => {
    if (
      typeof userDetails?.shippingAddress?.[0] === "object" &&
      userDetails?.shippingAddress?.[0] !== null
    ) {
      setAddress({ ...userDetails?.shippingAddress?.[0] });
    }
  }, [userDetails]);
  const [isModalOpen, setIsModalOpen] = useState({
    addressModal: false,
    cardDetailsModal: false,
    savedAddressModal: false,
    applyCouponModal: false,
    benifits: false,
  });
  const orderForZeroAmount = async () => {
    const giftingDetails = isGift
      ? {
        recieverName: recipientName,
        recieverEmailPhone: recipientEmail,
        recieverMessage: recieverMessage,
        sender: sender,
      }
      : "";
    if (isGift && showgift !== "false") {
      setLoading(false);
      return antdMessageError(
        "You can not Gift a subscription with 100% discount"
      );
    }
    await API.payment.pgIntegrationOnetimeForAll({
      clientId: searchParams.get("clientId") || "",
      subscriptionId:
        searchParams.get("subsId") || searchParams.get("subId") || "",
      anonId: searchParams.get("anonId") || "",
      tierId: searchParams.get("tierId") || "",
      type: "SUBSCRIPTION",
      clientContentId: searchParams.get("clientContentId") || "",
      currency: searchParams.get("currency") ? subsDetailsData.currency : "",
      couponCode: activeCoupon,
      manuallyRenewed: renew,
      clientReferenceId: searchParams.get("clientReferenceId") || "",
      giftedByUser: giftedByUserRef.current,
      gifterPurchaseId: gifterPurchaseIdRef.current,
      isGiftCoupon: isGiftCouponRef.current,
      paywallId: normalizeParam(searchParams.get("paywallId")),
      paywallType: normalizeParam(searchParams.get("paywallType")),
    });
    const secondStep =
      new URLSearchParams(window.location.search).get("secondStep") || "";
    const thirdstep =
      new URLSearchParams(window.location.search).get("thirdStep") || undefined;
    const popUpId =
      new URLSearchParams(window.location.search).get("popUpId") || undefined;
    const secondaryDetails =
      new URLSearchParams(window.location.search).get("secondaryDetails") ||
      undefined;
    const url = new URL(
      `${window.location.origin}/thankyou?clientContentId=${searchParams.get(
        "clientContentId"
      )}&clientId=${searchParams.get(
        "clientId"
      )}&secondStep=${secondStep}&thirdstep=${thirdstep}&popUpId=${popUpId}&secondaryDetails=${secondaryDetails}`
    );
    window.location.href = url.toString();
  };
  const callRoutingConfig = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const clientId = searchParams.get("clientId") || "";
    const annonId = searchParams.get("anonId") || "";
    const clientContentId = searchParams.get("clientContentId") || "";
    const routingResponse = await API.payment.CallRouting({
      clientId: clientId,
      annonId : annonId,
      clientContentId : clientContentId,
      userId : "",
      // accessToken: accessToken.accessToken,
    });

    if (!API.validators.checkSuccessCode(routingResponse))
      return console.error("Unable To fetch data");
    localStorage.setItem("logoUrl", routingResponse.data.logoUrl);
    const searchParams1 = new URLSearchParams(window.location.search);
    const paramGateway = searchParams1.get("paymentGateway");
    const gatewayMethods = searchParams1.get("paymentMethod");
    //hardcoding to check for cybersource
    if (
      paramGateway?.toUpperCase() === "STRIPE" ||
      paramGateway?.toUpperCase() === "RAZORPAY" ||
      paramGateway?.toUpperCase() === "PAYPAL" ||
      paramGateway?.toUpperCase() === "CYBERSOURCE"
    ) {
      // @ts-ignore
      const temp = transformToArray(gatewayMethods);
      setRouting({
        ...routingResponse?.data,
        gateway: paramGateway?.toUpperCase(),
        paymentMethod : temp,
      });
    } else {
      setRouting({ ...routingResponse?.data });
    }
    return routingResponse?.data;
  };

  const [inputValue, SetInputValue] = useState("");

  const GenderArray = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "OTHERS", label: "Others" },
  ];
  const filteredOptions = Country_flag_json.filter(
    (option) =>
      option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.dail_code.toLowerCase().includes(inputValue.toLowerCase())
  );
  const getCyberSourcedata = async () => {
    sendClickEvent();
    const result = await checkForUserdata();
    if (result === "STOP") {
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const clientId = searchParams.get("clientId") || "";
    const cardData = expiryDate.split("/");
    const cardExpiryMonth = cardData[0];
    let cardExpiryYear = "";
    if (cardData[1] != undefined) {
      cardExpiryYear = `20${cardData[1]}`;
    } else {
      cardExpiryYear = "";
    }

    // const cardNumber= ;
    // let securityCode = "";

    setbuttonLoading(true);
    if (subsDetailsData.convertedPrice === 0 && renew === false) {
      setLoading(true);
      await orderForZeroAmount();
      return;
    }
    try {
      const data = await API.user.CyberSourceSetUp({
        clientId,
        cardExpiryMonth,
        cardExpiryYear,
        cardNumber: cardNumber.replaceAll(/\s/g, ""),
        securityCode,
        cardTokenId: cardToken,
        cardType: cardType,
        nameOnCard: cardHolderName,
      });
      setCyberSourcedata({
        accessToken: data.data.data.accessToken,
        deviceDataCollectionUrl: data.data.data.deviceDataCollectionUrl,
        refrenceId: data.data.data.referenceId,
      });
    } catch (error) {
      setbuttonLoading(false);
      antdMessageError("Enter card details to proceed with payment.");
    }

    // CyberSource({accessToken:data.data.accessToken,deviceDataCollectionUrl:data.data.deviceDataCollectionUrl,refrenceId:data.data.referenceId})
  };

  const callStripe = async () => {
    sendClickEvent();
    const result = await checkForUserdata();
    if (result === "STOP") {
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    let succesfrontendurltemp = `${window.location.origin}/thankyou?`;
    if (subsDetailsData.convertedPrice === 0 && renew === false) {
      setLoading(true);

      await orderForZeroAmount();
      return;
    }
    const numberOfLicense = Number(searchParams.get("numberOfLicense"));
    const giftingDetails = isGift
      ? {
        recieverName: recipientName,
        recieverEmailPhone: recipientEmail,
        recieverMessage: recieverMessage,
        sender: sender,
      }
      : "";
    // userDetails;

    const sub = {
      brandlogoUrl: routing.logoUrl,
      successFrontendUrl: succesfrontendurltemp,
      failureFrontendUrl: `${window.location.href}`,
      subscriptionId: searchParams.get("subsId") || searchParams.get("subId"),
      tierId: searchParams.get("tierId"),
      amount: searchParams.get("amount")
        ? +subsDetailsData.convertedPrice + tax
        : "",
      currency: searchParams.get("currency") ? subsDetailsData.currency : "",
      type: "SUBSCRIPTION",
      anonId: searchParams.get("anonId"),
      userDetails: {
        ...userDetails,
        ...(isGift && { isGift: isGift }),
        ...(giftingDetails && { giftingDetails }),
      },
      pageType: searchParams.get("pageType"),
      clientId: searchParams.get("clientId"),
      clientContentId: searchParams.get("clientContentId"),
      renewSubscription: renew,
      // viewId: subscriptionPageParams?.viewId,
      userId: userDetails._id,
      eventLocation: "SRP",
      paywallId: normalizeParam(searchParams.get("paywallId")),
      paywallType: normalizeParam(searchParams.get("paywallType")),
      userToken: localStorage.getItem("refreshToken"),
      // couponCode: subscriptionPageParams.couponCode,
      // numberOfLicense: subscriptionPageParams?.numberOfLicense,
      journeyId:normalizeParam(searchParams.get("journeyId")),
      segmentId: normalizeParam(searchParams.get("segmentId")),
      couponCode: activeCoupon,
      clientReferenceId: searchParams.get("clientReferenceId") || "",
      numberOfLicense: Number(numberOfLicense),
      landingPageId: searchParams.get("landingPageId"),
      platformType : device,
    };
    setsubscriptionContentDetails({ ...sub });
  };
  useEffect(() => {
    //@ts-ignore
    if (subscriptionContentDetails?.type === "SUBSCRIPTION") {
      if (routing.gateway === "STRIPE") setisStripe(true);
      if (routing.gateway === "PAYPAL") setisPaypal(true);
    }
  }, [subscriptionContentDetails]);
  const checkForUserdata = async () => {
    if (
      (checkoutSetting.deliveryAddress.customization.adsFreeSubscription
        .mandatory &&
        subsDetailsData.adFree) ||
      (checkoutSetting.deliveryAddress.customization.digitalSubscription
        .mandatory &&
        subsDetailsData.digital) ||
      (checkoutSetting.deliveryAddress.customization.physicalSubscription
        .mandatory &&
        subsDetailsData.physical)
    ) {
      if (
        !address.area ||
        !address.country ||
        !address.name ||
        !address.pincode ||
        !address.state
      ) {
        antdMessageError("Please provide full delivery address");
        return "STOP";
      }
    }
    if (checkoutSetting.contactInfo.email.mandatory) {
      if (!(userDetails.email || userDetails.secondaryEmail)) {
        antdMessageError("Please provide an Email");
        return "STOP";
      }
    }
    if (checkoutSetting.contactInfo.mobile.mandatory) {
      if (!(userDetails.phoneNumber || userDetails.secondaryPhone)) {
        antdMessageError("Please provide an Phone Number");
        return "STOP";
      }
    }
    if (checkoutSetting.contactInfo.gender.mandatory) {
      if (!userDetails.gender) {
        antdMessageError("Please provide Your gender");
        return "STOP";
      }
    }
    if (checkoutSetting.contactInfo.DOB.mandatory) {
      if (!userDetails.dateOfBirth) {
        antdMessageError("Please provide Date of Birth");
        return "STOP";
      }
    }
    if (isGift && showgift !== 'false') {
      if (checkoutSetting.giftingDetails.recipientEmailPhone.mandatory) {
        if (recipientEmail.length < 5) {
          antdMessageError("Please provide recipient Email");
          return "STOP";
        }
      }
      if (checkoutSetting.giftingDetails.message.mandatory) {
        if (recieverMessage.length < 5) {
          antdMessageError("Please provide recipient Message");
          return "STOP";
        }
      }
      if (checkoutSetting.giftingDetails.recipientName.mandatory) {
        if (recipientName.length < 5) {
          antdMessageError("Please provide recipient Name");
          return "STOP";
        }
      }
    }

    // return
    if (checkoutSetting.contactInfo.nameInput.mandatory) {
      if (!userDetails.name) {
        antdMessageError("Please provide name");
        return "STOP";
      }
    }
    if (checkoutSetting.billingAddress) {
      if (!billingAddress.area) {
        antdMessageError("Please provide billing address area");
        return "STOP";
      }
      if (!billingAddress.country) {
        antdMessageError("Please provide billing address Country");
        return "STOP";
      }
      if (!billingAddress.pincode) {
        antdMessageError("Please provide billing address pincode");
        return "STOP";
      }
      if (!billingAddress.state) {
        antdMessageError("Please provide billing address state");
        return "STOP";
      }
    }
    if (checkoutSetting?.taxId.taxIdInput) {
      if (!userDetails.userTaxId) {
        if (
          checkoutSetting?.taxId.retailMandatory ||
          checkoutSetting?.taxId.corporateMandatory
        ) {
          antdMessageError("Please provide tax Id");
          return "STOP";
        }
      }
    }
    let accessToken = localStorage.getItem("accessToken");

    if (userLoggedIn) {
      await API.payment.PutUserData({
        userdata: {
          ...userDetails,
          ...(userDetails.email === "" && { email: undefined }), // Omit email if it is an empty string
          ...(userDetails.gender === "" && { gender: undefined }), // Omit email if it is an empty string
          ...(userDetails.name === "" && { name: undefined }), // Omit email if it is an empty string

          shippingAddress: address.area
            ? [...(userDetails?.shippingAddress || []), address]
            : [...(userDetails?.shippingAddress || [])], // Ensure it's always an array
          billingAddress: billingAddress.area
            ? [...(userDetails?.billingAddress || []), billingAddress]
            : [...(userDetails?.billingAddress || [])],
        },
        accessToken: "",
      });
    }
  };
  const [loadScript, setLoadScript] = useState(false);
  const [captureContext, setCaptureContext] = useState<string>('');
  const checkBrowser = () =>{
    // @ts-ignore
    if (window.ApplePaySession) {
      // @ts-ignore
      if (ApplePaySession.canMakePayments()) {
        console.log("✅ Apple Pay is available");
        setSupportApple(true);
      } else {
        console.log(" user can't make payments (no card or setup).");
      }
    } else {
      setSupportApple(false);
      console.log("Apple Pay is not supported in this browser.");
    }
  }
  useEffect(()=>{
    checkBrowser();
  },[])
  const getApplePay = async ({price , currency} : {price : number ; currency : string;}) => {
    setLoadScript(false);
    let accessToken = localStorage.getItem("accessToken");
    const response = await API.payment.getCaptureContext({amount : price === 0 ? 1 : price , currency : currency , accessToken : accessToken || '', clientId :searchParams.get("clientId"),paymentTypes : unifiedMethods });
    const token = response?.data?.data;
    setCaptureContext(token);
    const x = jwtDecode(token);
    const script = document.createElement("script");
    script.type = "text/javascript";
    // @ts-ignore
    script.src = x?.ctx?.[0]?.data?.clientLibrary;
    // @ts-ignore
    script.integrity = x?.ctx?.[0]?.data?.clientLibraryIntegrity;
    script.async = true;
    script.crossOrigin = "anonymou";
    document.head.appendChild(script);

    script.onload = () => {
      console.log("CyberSource script loaded");
      setLoadScript(true);
    };
  }

  const orderPay = async(token : string) =>{
    sendClickEvent();
    let accessToken = localStorage.getItem("accessToken");
    const orderObj = {
      "clientId": searchParams.get("clientId"),
      "clientContentId": searchParams.get("clientContentId") || "",
      "type": "SUBSCRIPTION",
      "tierId": searchParams.get("tierId"),
      "subscriptionId": searchParams.get("subsId") || searchParams.get("subId"),
      "anonId": searchParams.get("anonId"),
      "consumeFreeTrial": false,
      "manuallyRenewed": renew,
      "couponCode": activeCoupon,
      "landingPageId": searchParams.get("landingPageId"),
      "userDetails": {
          "name": userDetails.name,
          "email": userDetails.email,
          "phone": userDetails.phoneNumber,
          "shippingAddress": address,
          // "shippingAddress": {
          //     "name": "gfhjk",
          //     "state": "hgjk",
          //     "country": "AS",
          //     "pincode": "111111",
          //     "area": "hgjk"
          // },
          "countryCode": userDetails.countryCode,
          // "billingAddress": {
          //     "name": "gfhjk",
          //     "state": "hgjk",
          //     "country": "AS",
          //     "pincode": "111111",
          //     "area": "hgjk"
          // }
          'billingAddress': billingAddress,
      },
      "successFrontendUrl": "https://www.facebook.com",
      "failureFrontendUrl": "https://www.google.com",
      "cyberSourceReferenceId": "44af6054-7570-4bed-acce-bf4326c60720",
      "numberOfLicense": searchParams.get("numberOfLicense"),
      "paywallId": normalizeParam(searchParams.get("paywallId")),
      "paywallType": normalizeParam(searchParams.get("paywallType")),
      "platformType" : device,
      "tt": token,
    }
    try {
      setLoading(true);
      const orderType = renew ? "Renewal" : 'Order';
      const response = orderType === "Order" ? await API.payment.orderPay({ data: orderObj, accessToken: accessToken || '' }) : await API.payment.orderRenewal({ data: orderObj, accessToken: accessToken || '' });
      if (response?.data?.data?.status === 'AUTHORIZED') {
        const secondStep =
          new URLSearchParams(window.location.search).get("secondStep") || "";
        const thirdstep =
          new URLSearchParams(window.location.search).get("thirdStep") || undefined;
        const popUpId =
          new URLSearchParams(window.location.search).get("popUpId") || undefined;
        const secondaryDetails =
          new URLSearchParams(window.location.search).get("secondaryDetails") ||
          undefined;
        window.location.href = `${window.location.origin}/thankyou?clientContentId=${searchParams.get("clientContentId")}
        &clientId=${searchParams.get("clientId")}
        &secondStep=${secondStep}
        &thirdstep=${thirdstep}
        &popUpId=${popUpId}
        &secondaryDetails=${secondaryDetails}`
      }
    } catch (error) {
      console.log(error, "ERROR")
      antdMessageError("Payment Failed.");
      setLoading(false);
      getApplePay({ price: subsDetailsData?.convertedPrice + tax, currency: subsDetailsData?.currency });
    }
  }

  useEffect(() => {
    if (!loadScript) return;
    var showArgs = {
      containers: {
        paymentSelection: "#buttonPaymentListContainer"
      }
    };
    // @ts-ignore
    window.Accept(captureContext)
      .then(function (accept: any) {
        console.log(accept.unifiedPayments())
        return accept.unifiedPayments();
      })
      .then(function (up: any) {
        console.log(up.show())
        return up.show(showArgs);
      })
      .then(async (tt: any) => {
        console.log(userDetails , "userdata");
        console.log(tt , "Token");
        orderPay(tt);
        // transient_token.value = tt;
        // authForm.submit();
      });
  }, [loadScript,renew])

  const CreateOrderRazorPay = async () => {
    sendClickEvent();
    const result = await checkForUserdata();
    if (result === "STOP") {
      return;
    }
    let accessToken = localStorage.getItem("accessToken");

    //remove it for razorpay
    let userId = "";
    // alert('dfljkhisod')
    const searchParams = new URLSearchParams(window.location.search);
    // let accessToken = localStorage.getItem("accessToken") || "";
    if (accessToken != undefined && accessToken.length > 18) {
      const arrayToken = accessToken.split(".");
      const tokenPayload = JSON.parse(atob(arrayToken[1]));
      userId = tokenPayload.sub;
    }
    // alert(renew)
    if (subsDetailsData.convertedPrice === 0 && renew === false) {
      setLoading(true);

      await orderForZeroAmount();
      return;
    }
    // localStorage.setItem('userId',tokenPayload.sub)
    const secondStep =
      new URLSearchParams(window.location.search).get("secondStep") ||
      undefined;
    const popUpId =
      new URLSearchParams(window.location.search).get("popUpId") || undefined;
    const thirdstep =
      new URLSearchParams(window.location.search).get("thirdStep") || undefined;
    // alert(secondStep);
    // alert(thirdstep)
    // return
    const cardData = expiryDate.split("/");
    const month = cardData[0];
    let year = "";
    if (cardData[1] != undefined) {
      year = `20${cardData[1]}`;
    } else {
      year = "";
    }
    // const year = `20${cardData[1]}`;
    const paywallId = normalizeParam(searchParams.get("paywallId"));
    const paywallType = normalizeParam(searchParams.get("paywallType"));
    const contentId = searchParams.get("clientContentId");
    const orderObj = {
      clientId: searchParams.get("clientId"),
      SubscriptionId: searchParams.get("subsId") || searchParams.get("subId"),
      tierId: searchParams.get("tierId"),
      type: "SUBSCRIPTION",
      anonId: searchParams.get("anonId"),
      numberOfLicense: searchParams.get("numberOfLicense"),
      userId: userId,
      secondStep,
      popUpId,
      thirdstep,
      isGift,
      sender,
      recieverMessage,
      paywallId,
      contentId,
      paywallType,
      recipientEmail,
      recipientName,
      userDetails: {
        name: userDetails.name,
        email: userDetails.email,
        phone: userDetails.phoneNumber,
        shippingAddress: address,
        secondaryPhone: userDetails.secondaryPhone,
        secondaryEmail: userDetails.secondaryEmail,
        countryCode: userDetails.countryCode,
        billingAddress: billingAddress,
        userTaxId: userDetails.userTaxId,
      },
      cardType,
      renew,
      cyberSourceSessionId,
      routing,
      cardToken,
      cardNumber: cardNumber.replaceAll(/\s/g, ""),
      cardHolderName,
      month,
      year,
      tax,
      subsDetailsData,
      setLoading,
      couponCode: activeCoupon,
      clientContentId: searchParams.get("clientContentId") || "",
      platformType : device,
    };
    setLoading(true);
    callrzpSubscription(orderObj);
    return;
  };
  const setAddressValue = (value: any) => {
    setAddress({
      ...address,
      country: value,
    });
  };
  const redirectToLogin = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const clientId = searchParams.get("clientId") || "";
    const url = new URL(ssoRedirectUrl);
    // y.searchParams.set('clientId',clientId)
    url.searchParams.append("redirectUrl", window.location.href);
    url.searchParams.append("clientId", clientId);
    window.location.href = url.toString();
  };
  const disableFutureAndToday = (current: any) => {
    // Get today's date
    const today = new Date();
    // Set the current date to the end of yesterday
    today.setHours(23, 59, 59, 999);
    return current && current > today;
  };
  const cyberSourceCheckout = () => {
    // localStorage.setItem('userId',tokenPayload.sub)
    const secondStep =
      new URLSearchParams(window.location.search).get("secondStep") ||
      undefined;
    const thirdstep =
      new URLSearchParams(window.location.search).get("thirdStep") || undefined;
    const popUpId =
      new URLSearchParams(window.location.search).get("popUpId") || undefined;

    // alert(secondStep);
    // alert(thirdstep)
    // return
    const searchParams = new URLSearchParams(window.location.search);
    const cardData = expiryDate.split("/");
    const month = cardData[0];
    // const year = `20${cardData[1]}`;
    let year = "";
    if (cardData[1] != undefined) {
      year = `20${cardData[1]}`;
    } else {
      year = "";
    }
    const paywallId = normalizeParam(searchParams.get("paywallId"));
    const paywallType = normalizeParam(searchParams.get("paywallType"));
    const contentId = searchParams.get("clientContentId");
    const orderObj = {
      clientId: searchParams.get("clientId"),
      SubscriptionId: searchParams.get("subsId") || searchParams.get("subId"),
      tierId: searchParams.get("tierId"),
      type: "SUBSCRIPTION",
      anonId: searchParams.get("anonId"),
      numberOfLicense: searchParams.get("numberOfLicense"),
      secondStep,
      popUpId,
      thirdstep,
      isGift,
      sender,
      recieverMessage,
      recipientEmail,
      recipientName,
      paywallId,
      paywallType,
      contentId,
      cardType,
      userDetails: {
        name: userDetails.name,
        email: userDetails.email,
        phone: userDetails.phoneNumber,
        shippingAddress: address,
        secondaryPhone: userDetails.secondaryPhone,
        secondaryEmail: userDetails.secondaryEmail,
        countryCode: userDetails.countryCode,
        billingAddress: billingAddress,
        userTaxId: userDetails.userTaxId,
        // userDetails.shippingAddress[indexOfShipingAddress],
        // billingAddress:userDetails.shippingAddress[indexOfShipingAddress],
        // userDetails?.shippingAddress[indexOfShipingAddress],
        // billingAddress:userDetails?.shippingAddress[indexOfShipingAddress],
      },
      renew,
      cyberSourceSessionId,
      routing,
      cardToken,
      cardNumber: cardNumber.replaceAll(/\s/g, ""),
      cardHolderName,
      month,
      year,
      setLoading: setbuttonLoading,
      clientContentId: searchParams.get("clientContentId") || "",
      setShowStepUp,
      setStepUpToken,
      couponCode: activeCoupon,
      setStepUrl,
      setTransactionId,
      setInternelTransactionId,
      setCyberSourceSessionId,
      setCyberSourcedata,
      platformType : device,
    };
    callrzpSubscription(orderObj);
  };
  const checkSuccessCode = (response: any) => {
    return Math.floor(response.status / 100) === 2;
  };
  console.log(userDetails , "qwerty")
  const detectCountry = async (data: any) => {
    const detectCountry = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/auth/detect-country`,
    });
    if (checkSuccessCode(detectCountry)) {
      const value = Country_flag_json?.find(
        (e) => e?.code === detectCountry?.data?.countryCode
      );
      // setcode(value?.dail_code);
      setUserDetails({ ...data, countryCode: value?.dail_code });
    }
  };
  useEffect(() => {
    cyberSourceSessionId.length > 10 && cyberSourceCheckout();
  }, [cyberSourceSessionId]);
  useMemo(() => {
    if (routing.gateway === "CYBERSOURCE") {
      const script = document.createElement("script");
      const orgId = process.env.REACT_APP_ORGID;
      // alert('op9iuyttyio')

      script.type = "text/javascript";
      script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=${routing.merchantId}${randomUUid}`;
      script.async = true;
      document.head.appendChild(script);

      return () => {
        // Cleanup: Remove the script tag when the component unmounts
        document.head.removeChild(script);
      };
    }
  }, [routing.gateway]);

  const dropdownRender = (menu: React.ReactElement) => (
    <div>
      <div className={style["dropDown-search"]}>
        <Input
          placeholder="Search..."
          onChange={(e) => SetInputValue(e.target.value)}
        />
        <img src={Search_icon} alt="Search_icon" />
      </div>
      {menu}
    </div>
  );
  const handleExpiryDateChange = (e: any) => {
    let input = e.target.value;

    // Remove any non-numeric characters, except for "/"
    input = input.replace(/[^\d/]/g, "");

    // Only add "/" if the input length is increasing
    if (
      input.length === 2 &&
      !input.includes("/") &&
      input.length > expiryDate.length
    ) {
      input = input + "/";
    }

    // Limit the input to 5 characters (MM/YY)
    if (input.length > 5) {
      input = input.slice(0, 5);
    }

    setExpiryDate(input);
  };
  const redirectToSLP = async () => {
    setLoading(true);
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const rid =
        searchParams.get("rid") === "null" ? null : searchParams.get("rid");
      const redirecturl = searchParams.get("siteUrl") || "";
      const clientId = searchParams.get("clientId") || "";
      const ssoUrl = ssoRedirectUrl;
      const anonId = searchParams.get("anonId") || "";
      const paywallId = searchParams.get("paywallId") || "";
      const nonSLPClients = [
        "661907c2487ae1aba956dcc4",
        "663c631856e840159e994170",
      ];

      // Extract domain from redirecturl
      let targetDomain = "";
      try {
        if (redirecturl) {
          const urlObj = new URL(decodeURIComponent(redirecturl));
          targetDomain = urlObj.hostname;
        }
      } catch (error) {
        console.error("Invalid redirect URL:", error);
      }

      if (targetDomain && slpDomain && slpDomain.length>10 && targetDomain !== slpDomain) {
        console.log(
          `Redirecting to SLP domain (${slpDomain}) as ${targetDomain} does not match.`
        );
        window.location.href = `https://${slpDomain}?clientId=${clientId}`;
        return;
      }

      if (ssoUrl.length < 10 || !nonSLPClients.includes(clientId)) {
        try {
          const decodedRedirecturl = redirecturl
            ? decodeURIComponent(redirecturl)
            : "";
          const decodedSiteUrl = siteUrl ? decodeURIComponent(siteUrl) : "";
          const newRedirecturl = new URL(
            decodedRedirecturl || decodedSiteUrl || ""
          );
          console.log("Valid URL:", newRedirecturl.toString());
          newRedirecturl.searchParams.append("backClick", "true");
          window.location.href = newRedirecturl.href;
          return;
        } catch (error) {
          console.error("Invalid URL after decoding:", error);
        }
      }

      // Default redirect to SSO
      window.location.href = `${ssoUrl}?redirectUrl=${redirecturl}&clientId=${clientId}&anonId=${anonId}&contentId=null&paywallId=${paywallId}&back=true`;
    } finally {
      setLoading(false);
    }
  };

  const getUserDetials = async () => {
    const clientId =
      new URLSearchParams(window.location.search).get("clientId") || "";
    // const userData = await API.payment.userDetails({
    //   clientId: clientId || "",
    //   accessToken: "zddf",
    // });
    // alert('dkjhgiuk')
    const userData2 = await API.payment.getUserDetails({
      clientId: clientId || "",
      accessToken: localStorage.getItem('accessToken') || '',
    });
    setUserLoggedIn(true);
    const value = Country_flag_json?.find(
      (e) => e?.code === userData2.data.detectedCountry
    );
    setUserDetails({ ...userData2.data, countryCode: value?.dail_code });
    setLoading(false);
  };
  useEffect(() => {
    if (
      subsDetailsData?.gift?.gifting === "MANDATORY" &&
      subsDetailsData?.gift?.giftEnabled
    ) {
      if (showgift !== "false") {
        setIsGift(true);
      }
      setIsGiftMandatory(true);
      setRenew(false);
    } else {
      setIsGiftMandatory(false);
    }
    if (slpGift === "true") {
      setIsGift(true);
    }
  }, [subsDetailsData]);

  function formatNumber(num: number) {
    // Check if the number is a whole number
    if (num % 1 === 0) {
      return num; // Return as is for whole numbers
    }
    // Fix the number to 2 decimal places for non-whole numbers
    return parseFloat(num.toFixed(2));
  }

  const searchParams2 = new URLSearchParams(window.location.search);
  const siteUrl = searchParams2.get("siteUrl") || undefined;

  const handleCardNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const onlyNumbers = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    const formattedNumber = onlyNumbers.replace(/(.{4})/g, "$1 ").trim(); // Format as 'XXXX XXXX XXXX XXXX'

    setCardNumber(formattedNumber); // Update card number
    console.log(detectCardType(onlyNumbers), "jkytuioiuygf");

    setCardType(detectCardType(onlyNumbers)); // Detect and update card type
  };
  const contactInput =
    checkoutSetting.contactInfo.DOB.isRequired ||
    checkoutSetting.contactInfo.email.isRequired ||
    checkoutSetting.contactInfo.gender.isRequired ||
    checkoutSetting.contactInfo.mobile.isRequired ||
    checkoutSetting.contactInfo.nameInput.isRequired;

  if (isStripe === true) {
    return (
      <SubsStripePayment
        subscriptionContentDetails={subscriptionContentDetails}
      />
    );
  }

  if (isPaypal === true) {
    return (
      <PaypalPayment subscriptionContentDetails={subscriptionContentDetails} />
    );
  }
  if (showStepUp === true) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <StepUpForm
          stepUpToken={stepUpToken}
          transactionId={transactionId}
          cardToken={cardToken}
          internelTYransactionId={internelTYransactionId}
          stepUpUrl={stepUpUrl}
          cyberSourceSessionId={randomUUid}
        />
      </div>
    );
  }
  if (loading || priceLoading) {
    return (
      <>
        <Loader />
      </>
    );
  }
  if (isPurchased) {
    return (
      <Alreadypurchased
        userDetails={userDetails}
        logoUrl={routing.logoUrl}
        tnc={redirects.tnc}
        privPolicy={redirects.privPolicy}
      />
    );
  }
  return (
    <>
      <ApplyCoupon
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setCheckoutCoupon={setCheckoutCoupon}
        checkoutCoupon={checkoutCoupon}
        isCouponValidRef={isCouponValid}
        removedSlpCouponRef={removedSlpCoupon}
        // setRemovedSlpCoupon={setRemovedSlpCoupon}
        subsIdRef={subsIdRef}
        clientIdRef={clientIdRef}
      />
      <AddAddress
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        editingAddress={editingAddress}
        setEditingAddress={setEditingAddress}
        editingIndex={editingIndex}
        setTriggerApi={setTriggerApi}
      />

      <Benifits
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        benifits={subsDetailsData}
      />
      <SavedAddress
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        userDetails={userDetails}
        setIndexOfShipingAddress={setIndexOfShipingAddress}
        indexOfShipingAddress={indexOfShipingAddress}
        setUserDetails={setUserDetails}
        setEditingAddress={setEditingAddress}
        setEditingIndex={setEditingIndex}
      />
      <AddCardDetails
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setRefreshData={setRefreshData}
        refreshData={refreshData}
      />
      <div className={style["main-container"]}>
        <div className={style["header-logo"]}>
          <img
            className={style["image-logo"]}
            src={routing.logoUrl}
            alt="Demo_Image"
          />
        </div>
        <div style={{ flexGrow: 1 }}>
          <div className={style["container"]}>
            <div className={style["sub-container"]}>
              <div className={style["first-container"]}>
                {contactInput && (
                  <div className={style["box1-container"]}>
                    <div className={style["contact-details"]}>
                      <div className={style["contact-heading"]}>
                        <DropDownArrow
                          onClick={() => setContantDetails(!contantDetails)}
                          style={{
                            transform: contantDetails
                              ? "rotate(0deg)"
                              : "rotate(180deg)",
                            cursor: "pointer",
                          }}
                        />
                        <div className={style["contact-heading-text"]}>
                          Contact Details
                        </div>
                      </div>
                      {!userLoggedIn && (
                        <div className={style["already-have-account"]}>
                          Already Have an account?{" "}
                          <span
                            onClick={() => {
                              redirectToLogin();
                            }}
                            className={style["login"]}
                          >
                            Login
                          </span>
                        </div>
                      )}
                    </div>
                    {contantDetails && (
                      <>
                        {checkoutSetting.contactInfo.nameInput.isRequired && (
                          <div className={style["first-name-input"]}>
                            <Input
                              value={userDetails?.name}
                              onChange={(e) => {
                                setUserDetails({
                                  ...userDetails,
                                  name: e.target.value.trimStart(),
                                });
                              }}
                              placeholder="First Name & Last Name"
                            />
                          </div>
                        )}
                        <div className={style["input-text-container1"]}>
                          {checkoutSetting.contactInfo.email.isRequired && (
                            <div
                              className={style["email-id-input"]}
                              style={{
                                width:
                                  checkoutSetting.contactInfo.email
                                    .isRequired &&
                                    checkoutSetting.contactInfo.mobile.isRequired
                                    ? ""
                                    : "100%",
                              }}
                            >
                              <Input
                                disabled={userDetails.isEmailVerified}
                                onChange={(e) => {
                                  setUserDetails({
                                    ...userDetails,
                                    secondaryEmail: e.target.value,
                                  });
                                }}
                                value={
                                  userDetails?.email ||
                                  userDetails?.secondaryEmail
                                }
                                placeholder="Email id"
                              />
                            </div>
                          )}
                          {checkoutSetting.contactInfo.mobile.isRequired && (
                            <div
                              className={style["input-container"]}
                              style={{
                                width:
                                  checkoutSetting.contactInfo.email
                                    .isRequired &&
                                    checkoutSetting.contactInfo.mobile.isRequired
                                    ? ""
                                    : "auto",
                              }}
                            >
                              <img src={Mobile_icon} alt="Mobile_icon" />
                              <div className={style["dropDown-container"]}>
                                <Select
                                  disabled={userDetails.isPhoneVerified}
                                  value={userDetails.countryCode}
                                  placeholder={userDetails.countryCode || "+91"}
                                  dropdownRender={dropdownRender}
                                  onChange={(value) =>
                                    setUserDetails({
                                      ...userDetails,
                                      countryCode: value,
                                    })
                                  }
                                  popupMatchSelectWidth={250}
                                  filterOption={false}
                                  suffixIcon={<SelectArrowIcon />}
                                  className={dropDownStyle["common-select-box"]}
                                  popupClassName={
                                    dropDownStyle["common-dropdown-select"]
                                  }
                                  optionLabelProp="label"
                                >
                                  {filteredOptions.map((option, index) => (
                                    <Select.Option
                                      key={index}
                                      value={option.dail_code}
                                      label={option.dail_code}
                                      className={
                                        dropDownStyle["dropdown-options"]
                                      }
                                    >
                                      <div className={style["dropdown-flag"]}>
                                        <div
                                          className={style["flag-code"]}
                                          style={{ fontSize: "12px" }}
                                        >
                                          {option.dail_code}
                                        </div>
                                        <div className={style["flag-name"]}>
                                          {option.name}
                                        </div>
                                        <div className={style["flag"]}>
                                          {option.flag}
                                        </div>
                                      </div>
                                    </Select.Option>
                                  ))}
                                </Select>
                              </div>
                              <div className={style["vertical-line"]}></div>
                              <Input
                                disabled={userDetails.isPhoneVerified}
                                value={
                                  userDetails.phoneNumber ||
                                  userDetails.secondaryPhone
                                }
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  );
                                  setUserDetails({
                                    ...userDetails,
                                    secondaryPhone: numericValue,
                                  });
                                }}
                                placeholder={"Mobile"}
                              />
                            </div>
                          )}
                        </div>
                        <div className={style["input-text-container2"]}>
                          {checkoutSetting.contactInfo.DOB.isRequired && (
                            <DatePicker
                              onChange={(e) => {
                                if (e) {
                                  const utcDate = new Date(
                                    Date.UTC(
                                      e.year(),
                                      e.month(),
                                      e.date(),
                                      e.hour(),
                                      e.minute(),
                                      e.second(),
                                      e.millisecond()
                                    )
                                  ).toISOString();

                                  setUserDetails({
                                    ...userDetails,
                                    dateOfBirth: utcDate,
                                  });
                                }
                              }}
                              placeholder={
                                userDetails?.dateOfBirth?.text ||
                                "Date of Birth"
                              }
                              inputReadOnly={true}
                              defaultValue={
                                userDetails.dateOfBirth
                                  ? dayjs(userDetails.dateOfBirth)
                                  : undefined
                              }
                              suffixIcon={<CalenderIcon />}
                              className={style["date-picker-input"]}
                              style={{
                                width:
                                  checkoutSetting.contactInfo.DOB.isRequired &&
                                    checkoutSetting.contactInfo.gender.isRequired
                                    ? ""
                                    : "100%",
                              }}
                              disabledDate={disableFutureAndToday}
                            />
                          )}
                          {checkoutSetting.contactInfo.gender.isRequired && (
                            <div
                              className={style["gender-input"]}
                              style={{
                                width:
                                  checkoutSetting.contactInfo.DOB.isRequired &&
                                    checkoutSetting.contactInfo.gender.isRequired
                                    ? ""
                                    : "100%",
                              }}
                            >
                              <CustomDropDownForSelect
                                onChangeForSelect={(e: any) =>
                                  setUserDetails({ ...userDetails, gender: e })
                                }
                                options={{ array: GenderArray, key: "value" }}
                                defaultValue={userDetails?.gender || undefined}
                                label={{ array: GenderArray, key: "label" }}
                                placeholder="Gender"
                                customStyle={{
                                  height: "40px",
                                  border: "1px solid #dedede",
                                }}
                                hoverColor="#E6E6E6"
                                dropdownStyle={{ zIndex: 1050 }}
                              // onChangeForSelect={()}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
                {showAddress && (
                  <div>
                    <div
                      className={style["contact-heading-text"]}
                      style={{ margin: "16px 0px" }}
                    >
                      Delivery Address
                    </div>

                    {typeof userDetails?.shippingAddress?.[0] === "object" &&
                      userDetails?.shippingAddress?.[0] !== null && (
                        <div>
                          <div className={style["address-container"]}>
                            <div className={style["address-name"]}>
                              {
                                userDetails?.shippingAddress[
                                  indexOfShipingAddress
                                ].name
                              }
                            </div>
                            <div className={style["address"]}>
                              <span>
                                {
                                  userDetails?.shippingAddress[
                                    indexOfShipingAddress
                                  ].area
                                }
                                ,{" "}
                              </span>
                              <span>
                                {
                                  userDetails?.shippingAddress[
                                    indexOfShipingAddress
                                  ].state
                                }
                                ,{" "}
                              </span>
                              <span>
                                {
                                  userDetails?.shippingAddress[
                                    indexOfShipingAddress
                                  ].country
                                }{" "}
                                -{" "}
                              </span>
                              <span>
                                {
                                  userDetails?.shippingAddress[
                                    indexOfShipingAddress
                                  ].pincode
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    {typeof userDetails?.shippingAddress?.[0] === "object" &&
                      userDetails?.shippingAddress?.[0] !== null && (
                        <div className={style["add-and-change-address"]}>
                          <div
                            className={style["add-address"]}
                            onClick={() => {
                              setIsModalOpen({
                                ...isModalOpen,
                                addressModal: true,
                              });
                              setEditingIndex(null);
                            }}
                          >
                            Add Address
                          </div>
                          <div
                            className={style["add-address"]}
                            onClick={() =>
                              setIsModalOpen({
                                ...isModalOpen,
                                savedAddressModal: true,
                              })
                            }
                          >
                            Change address
                          </div>
                        </div>
                      )}
                    {userDetails?.shippingAddress?.length === 0 && (
                      <div style={{ marginTop: "16px" }}>
                        <div className={style["input-text-container1"]}>
                          <div className={style["pincode-input"]}>
                            <Input
                              value={address.pincode}
                              onChange={(e) => {
                                const value = e.target.value;
                                const isValid = /^\d{0,10}$/.test(value);
                                if (isValid) {
                                  setAddress({
                                    ...address,
                                    pincode: value,
                                  });
                                }
                              }}
                              placeholder="PIN / ZIP Code"
                            />
                          </div>
                          <div className={style["pincode-input"]}>
                            <Input
                              value={address.state}
                              onChange={(e) => {
                                const value = e.target.value;
                                const isValid = /^[a-zA-Z\s]{0,100}$/.test(
                                  value
                                );
                                if (isValid) {
                                  setAddress({
                                    ...address,
                                    state: value,
                                  });
                                }
                              }}
                              placeholder="State"
                            />
                          </div>
                          <div className={style["pincode-input"]}>
                            {/* <Input
                              value={address.country}
                              onChange={(e) => {
                                const value = e.target.value;
                                const isValid = /^[a-zA-Z\s]{0,100}$/.test(
                                  value
                                );
                                if (isValid) {
                                  setAddress({
                                    ...address,
                                    country: value,
                                  });
                                }
                              }}
                              placeholder="Country"
                            /> */}
                            {subsDetailsData.countries.length > 0 && (
                              <CustomDropDownForSelect
                                placeholder="Shipping Country"
                                showSearch={true}
                                options={{
                                  array: subsDetailsData.countries,
                                  key: "name",
                                }}
                                label={{
                                  array: subsDetailsData.countries,
                                  key: "name",
                                }}
                                onChangeForSelect={(value: any) => {
                                  setAddressValue(
                                    Countries.find((v) => v.name === value)
                                      ?.code
                                  );
                                }}
                                getPopupContainer={(trigger: any) =>
                                  trigger.parentNode
                                }
                                dropdownStyle={{ zIndex: 1050 }}
                                customStyle={{
                                  border: "1px solid #dedede",
                                }}
                                hoverColor="#dedede"
                              />
                            )}
                          </div>
                        </div>
                        <div className={style["address-name-input"]}>
                          <Input
                            onChange={(e) => {
                              setAddress({ ...address, name: e.target.value });
                            }}
                            placeholder="First Name & Last Name"
                          />
                        </div>
                        <div className={style["address-name-input"]}>
                          <Input
                            onChange={(e) => {
                              setAddress({ ...address, area: e.target.value });
                            }}
                            placeholder="Full Address (House number, area... etc)"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {checkoutSetting.billingAddress && !billingSameAsShipping && (
                  <div>
                    <div
                      className={style["contact-heading-text"]}
                      style={{ margin: "16px 0px" }}
                    >
                      Billing Address
                    </div>
                    <div style={{ marginTop: "16px" }}>
                      <div className={style["input-text-container1"]}>
                        <div className={style["pincode-input"]}>
                          <Input
                            value={billingAddress.pincode}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^\d{0,10}$/.test(value);
                              if (isValid) {
                                setBillingAddress({
                                  ...billingAddress,
                                  pincode: value,
                                });
                              }
                            }}
                            placeholder="PIN / ZIP Code"
                          />
                        </div>
                        <div className={style["pincode-input"]}>
                          <Input
                            value={billingAddress.state}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^[a-zA-Z\s]{0,100}$/.test(value);
                              if (isValid) {
                                setBillingAddress({
                                  ...billingAddress,
                                  state: e.target.value,
                                });
                              }
                            }}
                            placeholder="State"
                          />
                        </div>
                        <div className={style["pincode-input"]}>
                          {/* <Input
                            value={billingAddress.country}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^[a-zA-Z\s]{0,100}$/.test(value);
                              if (isValid) {
                                setBillingAddress({
                                  ...billingAddress,
                                  country: e.target.value,
                                });
                              }
                            }}
                            placeholder="Country"
                          /> */}
                          <CustomDropDownForSelect
                            placeholder="Billing Country"
                            defaultValueForSelectOption={
                              billingAddress.country
                                ? Countries.find(
                                  (v) => v.code === billingAddress.country
                                )?.name || ""
                                : undefined
                            }
                            showSearch={true}
                            options={{ array: Countries, key: "name" }}
                            label={{ array: Countries, key: "name" }}
                            onChangeForSelect={(value: any) => {
                              // setAddressValue(Countries.find((v) => v.name === value)?.code);
                              setBillingAddress({
                                ...billingAddress,
                                country:
                                  Countries.find((v) => v.name === value)
                                    ?.code || "",
                              });
                            }}
                            getPopupContainer={(trigger: any) =>
                              trigger.parentNode
                            }
                            dropdownStyle={{ zIndex: 1050 }}
                            customStyle={{
                              width: "100%",
                              border: "1px solid #dedede",
                            }}
                          />
                        </div>
                      </div>
                      <div className={style["address-name-input"]}>
                        <Input
                          value={billingAddress.name}
                          onChange={(e) => {
                            setBillingAddress({
                              ...billingAddress,
                              name: e.target.value,
                            });
                          }}
                          placeholder="First Name & Last Name"
                        />
                      </div>
                      <div className={style["address-name-input"]}>
                        <Input
                          value={billingAddress.area}
                          onChange={(e) => {
                            setBillingAddress({
                              ...billingAddress,
                              area: e.target.value,
                            });
                          }}
                          placeholder="Full Address (House number, area... etc)"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {showAddress &&
                  checkoutSetting.billingAddress &&
                  (checkoutSetting.deliveryAddress.customization
                    .adsFreeSubscription.isRequired ||
                    checkoutSetting.deliveryAddress.customization
                      .digitalSubscription.isRequired ||
                    checkoutSetting.deliveryAddress.customization
                      .digitalSubscription.isRequired) && (
                    <div
                      className={style["checkbox"]}
                      style={
                        billingSameAsShipping
                          ? { margin: "12px 0px 0px 0px" }
                          : {}
                      }
                    >
                      <Checkbox
                        onClick={() => {
                          setbillingSameAsShipping(!billingSameAsShipping);
                          setBillingAddress({ ...address });
                        }}
                      />
                      <div>
                        <div className={style["billing-address"]}>
                          Billing Address
                        </div>
                        <div className={style["same-as-address"]}>
                          Same as Delivery Address
                        </div>
                      </div>
                    </div>
                  )}
                {subsDetailsData?.gift?.giftEnabled &&
                  (checkoutSetting.giftingDetails.message.isRequired === true ||
                    checkoutSetting.giftingDetails.recipientEmailPhone
                      .isRequired === true ||
                    checkoutSetting.giftingDetails.recipientName.isRequired ===
                    true) &&
                  !(showgift === "false") && (
                    <div
                      className={style["checkbox"]}
                      style={{
                        display: "block",
                        padding: "12px 12px 2px",
                        margin: "20px 0px",
                      }}
                    >
                      <div
                        className={style["flex-center"]}
                        style={{ gap: "10px" }}
                      >
                        <Checkbox
                          checked={isGift}
                          onClick={() =>
                            !isGiftMandatory &&
                            (setIsGift(!isGift), setRenew(false))
                          }
                          disabled={isGiftMandatory}
                        />
                        <div className={style["contact-heading-text"]}>
                          This is a Gift
                        </div>
                      </div>
                      <div style={{ marginTop: "16px" }}>
                        <div className={style["input-text-container1"]}>
                          {checkoutSetting.giftingDetails.recipientName
                            .isRequired && (
                            <div className={style["email-id-input"]}>
                              <Input
                                value={recipientName}
                                onChange={(e) => {
                                  setrecipientName(e.target.value);
                                }}
                                placeholder="Recipient’s Name"
                              />
                            </div>
                          )}
                          {checkoutSetting.giftingDetails.recipientEmailPhone
                            .isRequired && (
                            <div className={style["email-id-input"]}>
                              <Input
                                value={recipientEmail}
                                onChange={(e) => {
                                  setrecipientEmail(e.target.value);
                                }}
                                placeholder="Recipient’s Email ID"
                              />
                            </div>
                          )}
                        </div>
                        {checkoutSetting.giftingDetails.message.isRequired && (
                          <div className={style["address-name-input"]}>
                            <TextArea
                              value={recieverMessage}
                              onChange={(e) => {
                                setRecieverMessage(e.target.value);
                              }}
                              placeholder="Personalised message"
                              style={{ height: "80px" }}
                            />
                          </div>
                        )}
                        <div className={style["address-name-input"]}>
                          <Input
                            value={sender}
                            onChange={(e) => {
                              setsender(e.target.value);
                            }}
                            placeholder="From"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                {checkoutSetting.taxId?.taxIdInput && (
                  <div
                    className={style["pincode-input"]}
                    style={{ marginTop: "10px" }}
                  >
                    <p
                      style={{
                        marginBottom: "3px",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      Enter Tax ID
                    </p>
                    <Input
                      type="text"
                      value={userDetails?.userTaxId}
                      onChange={(e) => {
                        setUserDetails({
                          ...userDetails,
                          userTaxId: e.target.value.trim(),
                        });
                      }}
                      placeholder="Enter Tax ID"
                      maxLength={30}
                    />
                  </div>
                )}
              </div>
              <div className={style["second-container"]}>
                <div style={{ flexGrow: 1 }}>
                  <div
                    className={style["order-summary"]}
                    style={{
                      backgroundColor: orderSummary ? "#ffffff" : "#f0f0f0",
                    }}
                  >
                    <div className={style["order-details"]}>
                      <div className={style["contact-heading"]}>
                        <div className={style["order-heading-text"]}>
                          Order Summary
                        </div>
                        <DropDownArrow
                          onClick={() => setOrderSummary(!orderSummary)}
                          style={{
                            transform: orderSummary
                              ? "rotate(0deg)"
                              : "rotate(180deg)",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <div className={style["order-price"]}>
                        {getCurrencySymbol(subsDetailsData.currency)}
                        {formatNumber(+subsDetailsData.convertedPrice + tax)}
                      </div>
                    </div>
                    {orderSummary && (
                      <>
                        <hr
                          style={{
                            border: "0.5px solid rgba(135, 135, 135, 0.1)",
                          }}
                        />
                        <div>
                          <div
                            style={{ alignItems: "start", padding: "0px 8px" }}
                          >
                            <div
                              className={style["flex-justify-space-between"]}
                            >
                              <div className={style["subs-duration"]}>
                                Duration:{" "}
                                {getWordsFromDuration(
                                  subsDetailsData.duration,
                                  subsDetailsData.durationType
                                )}
                              </div>
                              {siteUrl && (
                                <div
                                  onClick={() => redirectToSLP()}
                                  className={style["change-plan"]}
                                >
                                  Change Plan
                                </div>
                              )}
                            </div>
                            <div className={style["subs-plan-name"]}>
                              {subsDetailsData.name}
                            </div>
                            {subsDetailsData.benefits.length > 0 && (
                              <div
                                onClick={() => {
                                  setIsModalOpen({
                                    ...isModalOpen,
                                    benifits: true,
                                  });
                                }}
                                className={style["view-benefits-offers"]}
                              >
                                View all benefits & offers
                              </div>
                            )}
                          </div>
                          <div
                            style={{ marginTop: "20px", padding: "0px 10px" }}
                          >
                            {activeCoupon ? (
                              <>
                                <div
                                  className={
                                    style["flex-justify-space-between"]
                                  }
                                  style={{ marginTop: "10px" }}
                                >
                                  <div className={style["apply-coupon-text"]}>
                                    Applied Coupon
                                  </div>
                                </div>

                                <div
                                  className={
                                    style["flex-justify-space-between"]
                                  }
                                  style={{ marginTop: "10px" }}
                                >
                                  <div
                                    className={style["flex-center"]}
                                    style={{ gap: "10px" }}
                                  >
                                    <div className={style["apply-coupon-code"]}>
                                      {activeCoupon}
                                    </div>
                                    <div
                                      className={
                                        style["apply-coupon-saved-rupess"]
                                      }
                                    >
                                      {`Saved ${
                                        subsDetailsData?.currency
                                          ? getCurrencySymbol(
                                              subsDetailsData.currency
                                            )
                                          : ""
                                      }${
                                        subsDetailsData?.couponDiscountPrice
                                          ? formatNumber(Number(subsDetailsData?.couponDiscountPrice))
                                          : 0
                                      }`}
                                    </div>
                                  </div>
                                  <div
                                    className={style["remove-coupon"]}
                                    onClick={() => {
                                      setCheckoutCoupon("");
                                      removedSlpCoupon.current = true;
                                      // setRemovedSlpCoupon(true);
                                      isCouponValid.current = false;
                                    }}
                                  >
                                    Remove
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div
                                className={style["flex-justify-space-between"]}
                                style={{ marginTop: "10px" }}
                              >
                                <div className={style["apply-coupon-text"]}>
                                  Have a Coupon Code?
                                </div>
                                <div
                                  className={style["more-coupon-text"]}
                                  onClick={() =>
                                    setIsModalOpen({
                                      ...isModalOpen,
                                      applyCouponModal: true,
                                    })
                                  }
                                >
                                  Apply Coupon
                                </div>
                              </div>
                            )}
                          </div>

                          <div
                            style={{ marginTop: "20px", padding: "0px 16px" }}
                          >
                            <div
                              className={style["flex-justify-space-between"]}
                              style={{ marginBottom: "10px" }}
                            >
                              <div className={style["apply-coupon-text"]}>
                                Price
                              </div>
                              <div className={style["price-amount"]}>
                                {getCurrencySymbol(subsDetailsData.currency)}
                                {subsDetailsData.originalPrice}
                              </div>
                            </div>
                            {subsDetailsData.proRataDiscount > 0 && (
                              <div
                                className={style["flex-justify-space-between"]}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className={style["apply-coupon-text"]}>
                                  Pro-Rata Discount
                                </div>
                                <div
                                  className={style["price-amount"]}
                                  style={{ color: "#008045" }}
                                >
                                  -{getCurrencySymbol(subsDetailsData.currency)}
                                  {subsDetailsData.proRataDiscount}
                                </div>
                              </div>
                            )}
                            {/* {tax>0&& ( <div
                                className={style["flex-justify-space-between"]}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className={style["apply-coupon-text"]}>
                                 Tax
                                </div>
                                <div
                                  className={style["price-amount"]}
                                  // style={{ color: "#008045" }}
                                >
                                  +{subsDetailsData.currency}{formatNumber(tax)}
                                  
                                </div>
                              </div>)} */}
                            {/* <div className={style['flex-justify-space-between']} style={{ marginBottom: '10px' }}>
                            <div className={style['apply-coupon-text']}>GST @10%</div>
                            <div className={style['price-amount']}>₹95.00</div>
                          </div> */}
                            {subsDetailsData.couponDiscountPrice > 0 && (
                              <div
                                className={style["flex-justify-space-between"]}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className={style["apply-coupon-text"]}>
                                  Coupon Discount
                                </div>
                                <div
                                  className={style["price-amount"]}
                                  style={{ color: "#008045" }}
                                >
                                  -{" "}
                                  {getCurrencySymbol(subsDetailsData.currency)}
                                  {formatNumber(
                                    subsDetailsData?.couponDiscountPrice
                                  )}
                                </div>
                              </div>
                            )}
                            <hr
                              style={{
                                border: "0.5px solid rgba(135, 135, 135, 0.1)",
                              }}
                            />
                            <div
                              className={style["flex-justify-space-between"]}
                              style={{ marginBottom: "10px" }}
                            >
                              <div className={style["price-amount"]}>Total</div>
                              <div className={style["price-amount"]}>
                                {getCurrencySymbol(subsDetailsData.currency)}
                                {formatNumber(+subsDetailsData.convertedPrice)}
                              </div>
                            </div>
                            {/* {subsDetailsData.couponDiscountPrice&&( <div className={style['flex-justify-space-between']} style={{ marginBottom: '10px' }}>
                            <div className={style['apply-coupon-text']}>Coupon Discount</div>
                            <div className={style['price-amount']} style={{ color: '#008045' }}>-{subsDetailsData.couponDiscountPrice}</div>
                          </div>)} */}
                            {tax > 0 && (
                              <div
                                className={style["flex-justify-space-between"]}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className={style["apply-coupon-text"]}>
                                  Tax
                                </div>
                                <div
                                  className={style["price-amount"]}
                                // style={{ color: "#008045" }}
                                >
                                  +{getCurrencySymbol(subsDetailsData.currency)}
                                  {formatNumber(tax)}
                                </div>
                              </div>
                            )}
                            {inclusiveTax > 0 && (
                              <div
                                className={style["flex-justify-space-between"]}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className={style["apply-coupon-text"]}>
                                  Tax (Included in Total) :
                                </div>
                                <div
                                  className={style["price-amount"]}
                                // style={{ color: "#008045" }}
                                >
                                  {getCurrencySymbol(subsDetailsData.currency)}
                                  {formatNumber(inclusiveTax)}
                                </div>
                              </div>
                            )}
                            <hr
                              style={{
                                border: "0.5px solid rgba(135, 135, 135, 0.1)",
                              }}
                            />
                            <div
                              className={style["flex-justify-space-between"]}
                              style={{ marginBottom: "10px" }}
                            >
                              <div className={style["price-amount"]}>
                                To Pay
                              </div>
                              <div className={style["price-amount"]}>
                                {getCurrencySymbol(subsDetailsData.currency)}
                                {formatNumber(
                                  +subsDetailsData.convertedPrice + tax
                                )}
                              </div>
                            </div>
                            {showRenew && !isGift && (
                              <div
                                className={style["flex-center"]}
                                style={{ gap: "6px", marginTop: "20px" }}
                              >
                                <Switch
                                  checked={renew}
                                  onChange={(checked) => {
                                    setRenew(checked);
                                  }}
                                  size="small"
                                />
                                <div className={style["renew-text"]}>
                                  Renew automatically after{" "}
                                  {getWordsFromDuration(
                                    subsDetailsData.duration,
                                    subsDetailsData.durationType
                                  )}{" "}
                                  at{" "}
                                  <span className={style["renew-price"]}>
                                    {getCurrencySymbol(
                                      subsDetailsData.currency
                                    )}
                                    {formatNumber(+renewAmount)}
                                  </span>
                                </div>
                              </div>
                            )}
                            {showRenewline && !isGift && (
                              <div className={style["renew-text"]}>
                                Renew automatically after{" "}
                                {getWordsFromDuration(
                                  subsDetailsData.duration,
                                  subsDetailsData.durationType
                                )}{" "}
                                at{" "}
                                <span className={style["renew-price"]}>
                                  {getCurrencySymbol(subsDetailsData.currency)}
                                  {formatNumber(+renewAmount)}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {/* will do when cyber source is added */}
                  <div className={style["payment-method-container"]}>
                    {/* <div className={style['select-payment']}>Select Payment Method</div> */}
                    {/* <div className={style['payment-method']}>
                    <div className={style['apple-pay']}>
                      <ApplePay />
                    </div>
                    <div className={style['google-pay']}>
                      <GooglePay />
                    </div>
                  </div> */}
                  </div>
                  {/* <div className={style['flex-justify-center']} style={{ margin: '16px 0px 30px 0px' }}>
                  <DividerIcon />
                </div> */}
                  {/* @ts-ignore */}
                  {(routing.paymentMethod.includes("APPLE_PAY") || routing.paymentMethod.includes("GOOGLE_PAY")) && 
                  <>
                    <div id="buttonPaymentListContainer" style={{ marginTop: '15px'}}>
                    <button type="button" id="checkoutEmbedded" disabled={true} style={{height:'44px',width:'100%',borderRadius:'4px',fontSize:'16px',border:'0px', backgroundColor:'transparent'}}>
                    </button>
                  </div>
                 {/* @ts-ignore */} 
                 {((routing.paymentMethod.includes("GOOGLE_PAY") || (routing.paymentMethod.includes("APPLE_PAY") && supportApple)) && routing.paymentMethod.includes("CARD")) && <div style={{width:'100%',height:'30px',marginTop:'15px',textAlign:'center',color:'#b1b1a4'}}>
                    --------- Or ---------
                  </div>}
                  </>}
                  {/* @ts-ignore */}
                  {routing.gateway === "CYBERSOURCE" && routing.paymentMethod.includes("CARD") && renew && (
                    <>
                      {cardDetails.length > 0 && (
                        <div
                          className={style["contact-heading-text"]}
                          style={{ margin: "16px 0px" }}
                        >
                          Saved Cards
                        </div>
                      )}
                      {cardDetails.map((card: any, index: number) => (
                        <div
                          onClick={() => {
                            setCardToken(card._id);
                          }}
                          style={{
                            border:
                              cardToken === card._id ? "1px solid black" : "",
                          }}
                          className={style["select-card"]}
                        >
                          <div
                            className={style["flex-center"]}
                            style={{ gap: "10px" }}
                          >
                            <div className={style["card-number"]}>
                              **** {card.cardDetails.number.slice(-4)}
                              {/* {card.cardDetails.number} */}
                            </div>
                            <div className={style["line"]}></div>
                            <div className={style["card-number"]}>
                              {card?.nameOnCard}
                            </div>
                          </div>
                          <div
                            className={style["flex-center"]}
                            style={{ gap: "10px" }}
                          >
                            <div className={style["card-number"]}>
                              {/* {card.cardDetails.cardType} */}
                            </div>
                            <img
                              src={handleCardType(card.cardDetails.cardType)}
                              alt="AmericanExpressIcon"
                              className={style["card-img"]}
                            />
                          </div>
                        </div>
                      ))}
                      {cardDetails.length > 0 && (
                        <div
                          className={style["add-card"]}
                          onClick={() =>
                            setIsModalOpen({
                              ...isModalOpen,
                              cardDetailsModal: true,
                            })
                          }
                        >
                          <AddPlusIcon />
                          <div>Add Card</div>
                        </div>
                      )}

                      {cardDetails.length === 0 && (
                        <div className={style["card-form-container"]}>
                          <div className={style["label-name"]}>
                            Credit / Debit Card Details
                          </div>
                          <div style={{ marginBottom: "16px" }}>
                            <div className={style["first-name-input"]}>
                              <Input
                                placeholder="Full Name on the Card"
                                value={cardHolderName}
                                onChange={(e) =>
                                  setCardHolderName(e.target.value.trimStart())
                                }
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: "16px" }}>
                            <div className={style["first-name-input"]}>
                              <Input
                                value={cardNumber}
                                onChange={handleCardNumberChange}
                                placeholder="Card Number"
                                maxLength={19}
                              />
                            </div>
                          </div>
                          <div className={style["expiration-date"]}>
                            <div style={{ width: "70%" }}>
                              <div className={style["cvv-input"]}>
                                <Input
                                  onChange={handleExpiryDateChange}
                                  placeholder="MM/YY"
                                  value={expiryDate}
                                  maxLength={5}
                                />
                              </div>
                            </div>
                            <div style={{ width: "30%" }}>
                              <div className={style["cvv-input"]}>
                                <Input
                                  value={securityCode}
                                  onChange={(e) => {
                                    setSecurityCode(e.target.value);
                                  }}
                                  placeholder="CVV"
                                  style={{ textAlign: "center" }}
                                  maxLength={3}
                                  type="password"
                                />
                              </div>
                            </div>
                          </div>
                          {/* <div className={style["save-card"]}>
                        <Checkbox />
                        <div>Save card details with Razer pay gateway</div>
                      </div> */}
                        </div>
                      )}
                    </>
                  )}
                  {/* @ts-ignore */}
                  {(routing.gateway === "CYBERSOURCE" && routing.paymentMethod.includes("CARD")) &&
                    !renew &&
                    subsDetailsData.convertedPrice > 0 && (
                      <>
                        {cardDetails.length > 0 && (
                          <div
                            className={style["contact-heading-text"]}
                            style={{ margin: "16px 0px" }}
                          >
                            Saved Cards
                          </div>
                        )}
                        {cardDetails.map((card: any, index: number) => (
                          <div
                            onClick={() => {
                              setCardToken(card._id);
                            }}
                            style={{
                              border:
                                cardToken === card._id ? "1px solid black" : "",
                            }}
                            className={style["select-card"]}
                          >
                            <div
                              className={style["flex-center"]}
                              style={{ gap: "10px" }}
                            >
                              <div className={style["card-number"]}>
                                **** {card.cardDetails.number.slice(-4)}
                                {/* {card.cardDetails.number} */}
                              </div>
                              <div className={style["line"]}></div>
                              <div className={style["card-number"]}>
                                {card?.nameOnCard}
                              </div>
                            </div>
                            <div
                              className={style["flex-center"]}
                              style={{ gap: "10px" }}
                            >
                              <div className={style["card-number"]}>
                                {/* {card.cardDetails.cardType} */}
                              </div>
                              <img
                                src={handleCardType(card.cardDetails.cardType)}
                                alt="AmericanExpressIcon"
                                className={style["card-img"]}
                              />
                            </div>
                          </div>
                        ))}
                        {cardDetails.length > 0 && (
                          <div
                            className={style["add-card"]}
                            onClick={() =>
                              setIsModalOpen({
                                ...isModalOpen,
                                cardDetailsModal: true,
                              })
                            }
                          >
                            <AddPlusIcon />
                            <div>Add Card</div>
                          </div>
                        )}

                        {cardDetails.length === 0 && (
                          <div className={style["card-form-container"]}>
                            <div className={style["label-name"]}>
                              Credit / Debit Card Details
                            </div>
                            <div style={{ marginBottom: "16px" }}>
                              <div className={style["first-name-input"]}>
                                <Input
                                  placeholder="Full Name on the Card"
                                  value={cardHolderName}
                                  onChange={(e) =>
                                    setCardHolderName(
                                      e.target.value.trimStart()
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: "16px" }}>
                              <div className={style["first-name-input"]}>
                                <Input
                                  value={cardNumber}
                                  onChange={handleCardNumberChange}
                                  placeholder="Card Number"
                                  maxLength={19}
                                />
                              </div>
                            </div>
                            <div className={style["expiration-date"]}>
                              <div style={{ width: "70%" }}>
                                <div className={style["cvv-input"]}>
                                  <Input
                                    onChange={handleExpiryDateChange}
                                    placeholder="MM/YY"
                                    value={expiryDate}
                                    maxLength={5}
                                  />
                                </div>
                              </div>
                              <div style={{ width: "30%" }}>
                                <div className={style["cvv-input"]}>
                                  <Input.Password
                                    value={securityCode}
                                    onChange={(e) => {
                                      setSecurityCode(e.target.value);
                                    }}
                                    placeholder="CVV"
                                    style={{ textAlign: "center" }}
                                    maxLength={3}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div className={style["save-card"]}>
                        <Checkbox />
                        <div>Save card details with Razer pay gateway</div>
                      </div> */}
                          </div>
                        )}
                      </>
                    )}
                </div>
                {/* @ts-ignore */}
                {(routing.gateway === "RAZORPAY" || (routing.gateway === "CYBERSOURCE" && routing.paymentMethod.includes("CARD")) || routing.gateway === "STRIPE" || routing.gateway === "PAYPAL")
                  && <Button
                  loading={buttonLoading}
                  style={{
                    background: checkoutSetting?.customizeCTA?.backgroundColor,
                    color: checkoutSetting?.customizeCTA?.color,
                    fontStyle: checkoutSetting?.customizeCTA?.fontStyle,
                    fontWeight: checkoutSetting?.customizeCTA?.fontWeight,
                  }}
                  onClick={() => {
                    routing.gateway === "RAZORPAY" && CreateOrderRazorPay();
                    routing.gateway === "CYBERSOURCE" && getCyberSourcedata();
                    (routing.gateway === "STRIPE" ||
                      routing.gateway === "PAYPAL") &&
                      callStripe();
                    //  routing.gateway==='PAYPAL' && setisPaypal(true)
                  }}
                  className={style["pay-btn"]}
                >
                  <div className={style["flex-center"]} style={{ gap: "10px" }}>
                    <div className={style["pay-btn-text"]}>
                      {getCurrencySymbol(subsDetailsData.currency)}
                      {formatNumber(+subsDetailsData.convertedPrice + tax)}
                    </div>
                    {/* <div className={style['strick-price']}>₹1100</div> */}
                  </div>
                  <div className={style["flex-center"]} style={{ gap: "10px" }}>
                    <div className={style["pay-btn-text"]}>
                      {checkoutSetting?.customizeCTA?.text || "Pay"}
                    </div>
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.705 0.283993C10.6114 0.191806 10.5006 0.118949 10.3789 0.0695846C10.2571 0.0202205 10.1269 -0.00468376 9.99554 -0.00370909C9.86419 -0.00273443 9.73432 0.0241029 9.61335 0.0752685C9.49237 0.126434 9.38265 0.200927 9.29047 0.294493C9.19828 0.38806 9.12542 0.498868 9.07606 0.620591C9.02669 0.742314 9.00179 0.87257 9.00276 1.00392C9.00374 1.13527 9.03058 1.26514 9.08174 1.38611C9.13291 1.50709 9.2074 1.6168 9.30097 1.70899L14.671 6.99899L1.00097 6.99899C0.735751 6.99899 0.481397 7.10435 0.293861 7.29189C0.106324 7.47942 0.000968212 7.73378 0.000968235 7.99899C0.000968258 8.26421 0.106324 8.51856 0.293861 8.7061C0.481397 8.89364 0.735751 8.99899 1.00097 8.99899L14.664 8.99899L9.29997 14.286C9.11602 14.4732 9.01305 14.7252 9.01327 14.9877C9.0135 15.2502 9.11691 15.502 9.30118 15.6889C9.48546 15.8758 9.73583 15.9828 9.99826 15.9867C10.2607 15.9907 10.5142 15.8913 10.704 15.71L17.628 8.88799C17.7459 8.7717 17.8395 8.63314 17.9034 8.48035C17.9673 8.32757 18.0002 8.16361 18.0002 7.99799C18.0002 7.83238 17.9673 7.66842 17.9034 7.51563C17.8395 7.36285 17.7459 7.22428 17.628 7.10799L10.704 0.284993L10.705 0.283993Z"
                        fill={checkoutSetting?.customizeCTA?.color || "white"}
                      />
                    </svg>
                  </div>
                </Button>}
              </div>
            </div>
          </div>
        </div>
        <Footer
          footerData={footerSettings}
          termsAndConditions={redirects.tnc}
          privacyAndPolicy={redirects.privPolicy}
        />
      </div>
      {cyberSourcedata?.accessToken?.length > 10 && (
        <CyberSource
          cyberSourcedata={cyberSourcedata}
          setCyberSourceSessionId={setCyberSourceSessionId}
        />
      )}
    </>
  );
};

export default Checkout;
